import { Stack, StackProps, Typography } from '@mui/material';
import { COLOR_BG_SECONDARY } from 'shared';

export const MintingHint = (props: StackProps) => {
  return (
    <Stack
      width="100%"
      bgcolor={COLOR_BG_SECONDARY}
      alignItems="flex-start"
      borderRadius={3}
      justifyContent="center"
      px={2}
      py={4}
      mb={2}
      {...props}
    >
      <Typography variant="body2" className="primary" mb={1}>
        🎉
        <Typography component="span" variant="body2" className="accent" ml={1}>
          We&#39;ve received your payment.
        </Typography>{' '}
        Your asset is now being minted — hang tight, this may take a moment!
      </Typography>
    </Stack>
  );
};
